import { FC, ReactNode } from 'react';
import { Typography } from '@mui/material';

interface SelectPlaceholderProps {
  color?: string;
  children: ReactNode;
}

const SelectPlaceholder: FC<SelectPlaceholderProps> = ({ children, color = '#0000008D' }) => (
  <Typography color={color} noWrap>
    {children}
  </Typography>
);

export default SelectPlaceholder;
